<template>
  <div class="backdrop-blur-[1px]">
    <section class="max-w-6xl mx-auto px-4 relative z-10">
      <div class="pb-4 text-base text-center pt-3.5">
        <p>
          Find our football predictions, odds and match information
          below.<template v-if="numberMatches && numberCompetitions">
            There are {{ numberMatches }} matches today across
            {{ numberCompetitions }} {{ competitionsString }}.</template
          >
        </p>
        <div
          class="flex flex-col md:flex-row justify-center items-center text-center gap-2 md:gap-x-4 mt-2"
        >
          <span
            v-if="subType == 'active'"
            class="flex flex-col md:flex-row items-center gap-2 md:gap-0"
          >
            <span class="flex items-center">
              <span
                style="color: blue; text-transform: uppercase; font-size: 13px"
                ><a href="https://discord.gg/yyk2vvnTsr"
                  >Join the discord</a
                ></span
              >
              <img
                src="@/assets/icons/discord.png"
                class="w-5 h-auto inline ml-1"
              />
            </span>
            <span class="mx-2 hidden md:inline" style="color: blue">|</span>
            <span class="flex items-center">
              <span
                style="color: blue; text-transform: uppercase; font-size: 13px"
                ><a
                  href="https://fantasy.premierleague.com/leagues/auto-join/py0zbv"
                  >Join our FPL league</a
                ></span
              >
              ✨
            </span>
            <span class="mx-2 hidden md:inline" style="color: blue">|</span>
            <span
              v-if="isActive"
              class="inline-flex flex-col justify-center items-center text-center"
              style="color: blue; text-transform: uppercase; font-size: 13px"
            >
              <button @click="exportDownload" class="text-gray-500">
                Exporting...(please allow a few mins)
              </button>
              <span class="bg-gray-100 h-4 rounded-md w-4/5 block">
                <span
                  class="progress bg-blue-700 block h-full"
                  :style="{ width: progress + '%' }"
                ></span>
              </span>
            </span>
            <span v-else-if="exportFailed" class="text-red-400"
              >Export failed, please email support@numbersgame.uk</span
            >
            <span
              v-else
              style="color: blue; text-transform: uppercase; font-size: 13px"
              ><button
                @click="exportDownload"
                :class="{
                  'uppercase text-gray-500': isActive,
                  uppercase: !isActive,
                }"
              >
                Export past results 📈
              </button></span
            >
          </span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import API from "../api";

export default {
  name: "SubscriberIntro",
  props: ["numberOfMatches", "numberOfCompetitions", "subscriptionType"],
  computed: {
    numberMatches() {
      return this.numberOfMatches;
    },
    numberCompetitions() {
      return this.numberOfCompetitions;
    },
    subType() {
      return this.subscriptionType;
    },
    competitionsString() {
      return this.numberOfCompetitions == 1 ? "competition" : "competitions";
    },
  },
  methods: {
    async exportDownload() {
      const api_export_url = "/export";
      this.isActive = true;
      this.progress = 0;

      // eslint-disable-next-line
      const response = await API.get(api_export_url, { responseType: "string" })
        .then((response) => {
          window.open(response.data, "exportCsv");
          this.isActive = false;
        })
        .catch((err) => {
          console.error(err);
          this.exportFailed = true;
          this.isActive = false;
        });
    },
  },
  data() {
    return {
      isActive: false,
      progress: 0,
      exportFailed: false,
    };
  },
};
</script>

<style scoped>
.progress {
  height: 100%;
  transition: width 0.3s ease-in-out;
  border-radius: 0.25rem;
}
</style>
